import { Injectable } from '@angular/core';
import { DataPrivacyViolationRepoService } from '../api/data-privacy-violation-repo/data-privacy-violation-repo.service';
import { DataPrivacyViolationModel } from '@client/app/models/data-privacy/violation.model';

@Injectable({
    providedIn: 'root',
})
export class DataPrivacyEntitiesViolationService {

    constructor (
        private dataPrivacyViolationRepoService: DataPrivacyViolationRepoService,
    ) { }

    update (violation: DataPrivacyViolationModel): Promise<DataPrivacyViolationModel> {
        return this.dataPrivacyViolationRepoService.update(violation);
    }
}
